module.exports = __webpack_public_path__ + "media/customizations/babcockranch/logo-new-5a7f2e0bd4de1a951e50ebd13c6258c0.png";